"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var baseFormTheme = require("../../styles/baseForm.scss");
var theme = require("../../styles/baseItem.scss");
var ui_1 = require("@vidazoo/ui");
var blackListDomainsList_1 = require("./blackListDomainsList");
var __1 = require("../..");
var selfTheme = require("./theme.scss");
var BlackListDomains = /** @class */ (function (_super) {
    tslib_1.__extends(BlackListDomains, _super);
    function BlackListDomains(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.hideClearMessage = function () {
            _this.setState(tslib_1.__assign({}, _this.state, { showClearMessage: false }));
        };
        _this.showClearMessage = function () {
            _this.setState(tslib_1.__assign({}, _this.state, { showClearMessage: true }));
        };
        _this.clearDomains = function () {
            var clearAllDomains = _this.props.clearAllDomains;
            clearAllDomains();
            _this.hideClearMessage();
        };
        _this.onDelete = function (item) {
            var onDelete = _this.props.onDelete;
            onDelete(item);
        };
        _this.onChangeExcludeBlackListDomainsByDomainList = function (e) {
            var onChange = _this.props.onChange;
            onChange(e);
            var value = __1.normalizeEventValue(e);
            if (!value) {
                onChange({
                    target: {
                        name: "excludeBlackListDomainList",
                        value: null,
                        type: "select-one"
                    }
                });
            }
        };
        _this.state = {
            showClearMessage: false
        };
        return _this;
    }
    BlackListDomains.prototype.componentWillMount = function () {
        if (this.props.allowDomainLists) {
            this.props.getDomainLists();
        }
    };
    BlackListDomains.prototype.renderClearMessage = function () {
        var showClearMessage = this.state.showClearMessage;
        return (React.createElement(ui_1.Modal, { external: true, exitOnClickOutside: true, onClose: this.hideClearMessage, isOpen: showClearMessage },
            React.createElement(ui_1.ConfirmPopMessage, { red: true, title: "Clear List?", text: React.createElement("span", null, "Are you sure you want to clear list?"), cancelText: "No, Cancel", confirmText: "Yes, Delete", onCancelClick: this.hideClearMessage, onConfirmClick: this.clearDomains })));
    };
    BlackListDomains.prototype.renderLoader = function () {
        return (React.createElement("div", { className: baseFormTheme.message },
            React.createElement(ui_1.Loader, { size: 1, gray: true, className: baseFormTheme.loader }),
            React.createElement(ui_1.PageMessage, { small: true, title: "Loading black list", description: "Please wait..." })));
    };
    BlackListDomains.prototype.renderError = function () {
        return (React.createElement("div", { className: theme.message },
            React.createElement(ui_1.PageMessage, { small: true, title: "Failed to load black list", description: "We are terribly sorry for the inconvenience and promise to try harder next time.", iconName: "icon-rejected-status" })));
    };
    BlackListDomains.prototype.renderContent = function () {
        var _a = this.props, isLoading = _a.isLoading, hasError = _a.hasError, domains = _a.domains;
        if (isLoading) {
            return this.renderLoader();
        }
        else if (hasError) {
            return this.renderError();
        }
        else if (domains) {
            return React.createElement(blackListDomainsList_1.default, tslib_1.__assign({}, this.props, { onDelete: this.onDelete }));
        }
    };
    BlackListDomains.prototype.render = function () {
        var _a = this.props, excludeDomains = _a.excludeDomains, addExcludeDomain = _a.addExcludeDomain, removeExcludeDomain = _a.removeExcludeDomain, mode = _a.mode, domains = _a.domains, excludeBlackListDomainsByDomainList = _a.excludeBlackListDomainsByDomainList, excludeBlackListDomainList = _a.excludeBlackListDomainList, domainLists = _a.domainLists, onChange = _a.onChange, isLoadingDomainLists = _a.isLoadingDomainLists, allowDomainLists = _a.allowDomainLists;
        return (React.createElement("div", { className: selfTheme.container },
            React.createElement("div", { className: "flex" },
                React.createElement("div", { className: theme.buttons },
                    React.createElement(ui_1.Button, { iconName: "icon-cancel-small", small: true, red: true, outlineGrayFill: true, onClick: this.showClearMessage }, "Clear List")),
                mode === __1.FormMode.Edit ?
                    React.createElement("div", { style: { display: "flex", marginLeft: "2.4rem", marginTop: "2.5rem", alignItems: "center" } },
                        React.createElement(ui_1.Label, { weight: 500, className: theme.title, size: 14, nunito: true, uppercase: false },
                            "Total Domains: ",
                            domains.length)) : null),
            React.createElement(ui_1.Surface, { level: 1, className: theme.item },
                React.createElement("div", { className: selfTheme.domainsHeader },
                    React.createElement(ui_1.Label, { className: theme.title, size: 13, weight: 700, monserrat: true }, "Exclude from BL Domains"),
                    allowDomainLists ? (React.createElement(ui_1.Switch, { name: "excludeBlackListDomainsByDomainList", small: true, label: "Exclude Domains By Domain List", checked: excludeBlackListDomainsByDomainList, onChange: this.onChangeExcludeBlackListDomainsByDomainList })) : null),
                excludeBlackListDomainsByDomainList ? (React.createElement(ui_1.Select, { searchable: true, required: true, isLoading: isLoadingDomainLists, maxItems: 10, value: excludeBlackListDomainList, onChange: onChange, name: "excludeBlackListDomainList", fill: true, items: domainLists, itemValueKey: "_id", itemLabelKey: "name" })) : (React.createElement(ui_1.Chips, { itemLabelKey: "url", itemValueKey: "url", name: "excludeDomains", emptyPlaceholder: "add url", allowCreate: true, allowOrder: false, onSelect: addExcludeDomain, onDelete: removeExcludeDomain, chips: excludeDomains, fill: true }))),
            this.renderContent(),
            this.renderClearMessage()));
    };
    BlackListDomains.defaultProps = {
        clearAllDomains: function () {
        },
        deleteDomain: function () {
        },
        addExcludeDomain: function () {
        },
        removeExcludeDomain: function () {
        },
        stickyScrollOffset: 0,
        excludeBlackListDomainsByDomainList: false,
        allowDomainLists: false
    };
    return BlackListDomains;
}(React.Component));
exports.default = BlackListDomains;
